import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installChunkRecovery } from "./lib/chunkRecovery.mjs";

installChunkRecovery();

const root = document.getElementById("root")!;
if (root.dataset.publicPrerender === "true") {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
